import React, { ReactNode } from "react"
import { StaticQuery, graphql } from "gatsby"
import Components from "../index"
import linkHandler from "../../helpers/storyblokLinkHandler"
import { blokType } from "../../types"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import {
  StyledCardEvent,
  StyledCardWrapper,
  StyledText,
  StyledDate,
  StyledTitleWrapper,
  StyledTitle,
  StyledDescWrapper,
  StyledDesc,
  StyledDegreeContainer,
  StyledDegreeItem,
  StyledCategoryContainer,
  StyledCategoryText,
  StyledCategory,
  StyledCategoryRotate,
  StyledCategoryShape,
  StyledIcon,
  StyledCardLink,
  StyledColorWrapper,
  StyledArrow,
} from "./partials"
import IconV2 from "../icon-v2"

export interface CardEventProps {
  date: string
  title: string
  description: string
  degrees: any
  category: string
  card_link: blokType[]
  remove_offset_margin: boolean
}

export const CardEventCmp: React.FC<CardEventProps> = ({
  date,
  title,
  description,
  degrees,
  category,
  card_link,
  remove_offset_margin,
}) => {
  const [shape, setShape] = React.useState("")
  const [icon, setIcon] = React.useState("")

  return (
    <>
      <StaticQuery
        query={graphql`
          query {
            allStoryblokDatasourceEntry(
              filter: { data_source: { in: ["event-card-assets"] } }
            ) {
              nodes {
                name
                value
                dimension_value
              }
            }
          }
        `}
        render={(data) => {
          const getShape = data.allStoryblokDatasourceEntry.nodes
            .filter(
              (entry: any) =>
                entry.name === category && entry.dimension_value !== null
            )
            .map((option: any) => option.value)
          setShape(getShape.toString())
          const getIcon = data.allStoryblokDatasourceEntry.nodes
            .filter(
              (entry: any) =>
                entry.name === category && entry.dimension_value !== null
            )
            .map((option: any) => option.dimension_value)
          setIcon(getIcon.toString())
        }}
      />
      <StyledCardEvent>
        <StyledCardWrapper>
          {card_link && (
            <>
              {card_link.length > 0 && (
                <StyledCardLink>
                  {card_link.map((l) =>
                    React.createElement(Components(l.component), {
                      key: l._uid,
                      blok: l,
                    })
                  )}
                </StyledCardLink>
              )}
            </>
          )}
          <StyledText>
            <StyledDate remove_offset_margin={remove_offset_margin}>
              {date && date}
            </StyledDate>
            <StyledTitleWrapper>
              {card_link && card_link.length > 0 ? (
                <a
                  href={linkHandler(card_link[0].link)}
                  title={card_link[0].title}
                  target={card_link[0].target}
                >
                  <StyledTitle>{title}</StyledTitle>
                </a>
              ) : (
                <StyledTitle>{title}</StyledTitle>
              )}
            </StyledTitleWrapper>
            <StyledDescWrapper>
              {description && (
                <StyledDesc>
                  {
                    unified()
                      .use(remarkParse)
                      .use(remarkRehype)
                      .use(rehypeReact as any, {
                        createElement: React.createElement,
                        components: remarkReactComponents,
                        Fragment: React.Fragment
                      })
                      .processSync(description.replace(/\n/g, "  \n"))
                      .result as ReactNode
                  }
                </StyledDesc>
              )}
            </StyledDescWrapper>
          </StyledText>
          <StyledColorWrapper remove_offset_margin={remove_offset_margin}>
            {degrees && (
              <StyledDegreeContainer>
                {degrees.map((item: string) => (
                  <StyledDegreeItem key={item}>{item}</StyledDegreeItem>
                ))}
              </StyledDegreeContainer>
            )}
            <StyledArrow category={category}>
              <IconV2 icon={"arrow-right"} />
            </StyledArrow>
          </StyledColorWrapper>
        </StyledCardWrapper>

        <StyledCategoryContainer>
          <StyledCategoryShape>
            <img src={shape} />
            <StyledCategory>
              <StyledCategoryRotate>
                <StyledCategoryText>{category && category}</StyledCategoryText>
                <StyledIcon>
                  <img src={icon} />
                </StyledIcon>
              </StyledCategoryRotate>
            </StyledCategory>
          </StyledCategoryShape>
        </StyledCategoryContainer>
      </StyledCardEvent>
    </>
  )
}
